import { jsx as _jsx } from "react/jsx-runtime";
function ThorchainIcon() {
    return (_jsx("svg", { className: "ui-size-full", viewBox: "0 0 20 22", fill: "currentColor", children: _jsx("path", { d: "M0 22L15.3585 15.5315L10.5003 10.6044L0 22ZM5.64071 5.67733L10.5003 10.6044L19.1793 0L5.64071 5.67733Z" }) }));
}
export default ThorchainIcon;
